module.exports = __webpack_public_path__ + "img/led_in_switch_65_game_boy.c9ec9484.png";